import React from "react";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormGroup
} from "material-ui/Form";
import Select from "material-ui/Select";
import Divider from "material-ui/Divider";
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails
} from "material-ui/ExpansionPanel";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";

import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import TimePicker from "material-ui-pickers/TimePicker";
import DatePicker from "material-ui-pickers/DatePicker";
import DateTimePicker from "material-ui-pickers/DateTimePicker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";

import { getISODateString, isVDVType, isSignalTEKQTType, isNaviTEKType } from "../../../common/utils";
import { withStyles } from "material-ui/styles";

import styles from "../styles";
moment.suppressDeprecationWarnings = true;

class Context extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerid: "show_all_customers",
      customer: "",
      name: "",
      synced: false,
      notsynced: false,
      createdat: "",
      enablesync: null,
      date: "",
      selectedDate: null
    };
    this.inputtimer = null;
  }

  handlejobnamefilter = e => {
    let state = { ...this.state };
    let name = e.target.value;
    this.setState({
      name: name.trim()
    });
    window.clearTimeout(this.inputtimer);
    this.inputtimer = setTimeout(() => {
      state.name = name;
      if (name.length && name.trim() !== "") {
        this.filterRecords(state);
      } else {
        state.name = "";
        this.filterRecords(state);
      }
    }, 500);
  };

  onChangeCustomer = e => {
    let state = { ...this.state };
    this.setState({
      customerid: e.target.value
    });
    state.customerid = e.target.value;
    this.filterRecords(state);
  };

  handleSyncChange = name => event => {
    let state = { ...this.state };
    this.setState({ [name]: event.target.checked });
    state[name] = event.target.checked;
    if (state.synced && state.notsynced) state.enablesync = null;
    else if (state.synced && !state.notsynced) state.enablesync = true;
    else if (!state.synced && state.notsynced) state.enablesync = false;
    else state.enablesync = null;
    this.setState({ enablesync: state.enablesync });
    this.filterRecords(state);
  };

  handleDeviceTypeChange = id => event => {
    let state = { ...this.state };
    this.setState({
      [id]: event.target.checked
    });
    state[id] = event.target.checked;

    if (id == "vdviipoepro") {
      this.setState({
        ["vdvii"]: event.target.checked,
        ["vdviiplus"]: event.target.checked,
        ["vdviipro"]: event.target.checked,
        ["poepro"]: event.target.checked
      });
      state["vdvii"] = event.target.checked;
      state["vdviiplus"] = event.target.checked;
      state["vdviipro"] = event.target.checked;
      state["poepro"] = event.target.checked;
    }

    if (id == "signaltekqtorpro") {
      this.setState({
        ["signaltekqt"]: event.target.checked,
        ["signaltekqtpro"]: event.target.checked,
      });
      state["signaltekqt"] = event.target.checked;
      state["signaltekqtpro"] = event.target.checked;
    }

    if (id == "navitekorpro") {
      this.setState({
        ["navitekiii"]: event.target.checked,
        ["navitekiiipro"]: event.target.checked,
      });
      state["navitekiii"] = event.target.checked;
      state["navitekiiipro"] = event.target.checked;
    }

    this.filterRecords(state);
  };

  handleDateChange = _date => {
    let state = { ...this.state };
    this.setState(
      {
        date: _date ? _date._d : null,
        selectedDate: _date
      },
      () => {
        (state.date = _date ? _date._d : null), (state.selectedDate = _date);
        this.filterRecords(state);
      }
    );
  };

  filterRecords = state => {
    const { setSearchParams, customers, deviceTypes } = this.props;
    const { name, enablesync, date, customerid, deviceType } = state;

    deviceTypes.find(x => x.id === "lantekiii")
      ? null
      : deviceTypes.push({
          id: "lantekiii",
          name: "LantekIII"
        });

    let search = [];
    if (name) {
      search.push({
        field: "name",
        searchvalue: name
      });
    }
    if (date) {
      let createdat = getISODateString(date);
      search.push({
        field: "createdat",
        searchvalue: createdat
      });
    }

    if (customerid && customerid != "show_all_customers") {
      let customer = customers
        ? customers.data.find(x => x.id === customerid)
        : null;
      search.push({
        field: "customerid",
        searchvalue: customer ? String(customer.id) : ""
      });
    }

    if (enablesync !== null) {
      search.push({
        field: "enablesync",
        searchvalue: String(enablesync)
      });
    }

    deviceTypes
      .map(item => item.id)
      .forEach(function(device) {
        state[device]
          ? search.push({
              field: "deviceid",
              searchvalue: device.includes("lantekiii") ? "null" : device,
              conditiontype: "or"
            })
          : false;
      });

    setSearchParams(state, search);
  };

  render() {
    const {
      classes,
      translate,
      setSearchParams,
      customers,
      deviceTypes
    } = this.props;
    deviceTypes.find(x => x.id === "lantekiii")
      ? null
      : deviceTypes.push({
          id: "lantekiii",
          name: "LantekIII"
        });

    let stqtEnabled = deviceTypes.filter(x => isSignalTEKQTType(x.id)).length > 0;
    let navitekEnabled = deviceTypes.filter(x => isNaviTEKType(x.id)).length > 0;
    let displayDeviceTypes = deviceTypes.filter(x => {
      return !isVDVType(x.id) && !isSignalTEKQTType(x.id) && !isNaviTEKType(x.id);
    });

    displayDeviceTypes.push({
      id: "vdviipoepro",
      name: "VDV II / PoE Pro"
    });
    if (stqtEnabled) {
      displayDeviceTypes.push({
        id: "signaltekqtorpro",
        name: "SignalTEK QT / SignalTEK QT Pro"
      });
    }
    if (navitekEnabled) {
      displayDeviceTypes.push({
        id: "navitekorpro",
        name: "NaviTEK III"
      });
    }

    const { customerid, name, date, selectedDate } = this.state;
    return (
      <div>
        <Typography>{translate("jobs_context_filter_description")}</Typography>

        <form className={classes.root} autoComplete="off">
          <FormControl className={classes.formControl}>
            <TextField
              id="search"
              label={translate("jobs_context_filter_jobname")}
              type="search"
              className={classes.textField}
              margin="normal"
              onChange={this.handlejobnamefilter}
              value={name}
              fullWidth
            />
          </FormControl>
          <FormControl className={classes.textField} margin="normal">
            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                <Typography className={classes.heading}>
                  {translate("jobs_context_filter_customers_panel")}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Select
                  value={customerid}
                  onChange={this.onChangeCustomer}
                  input={
                    <Input
                      name="customerid"
                      id="customerid"
                      value={customerid}
                      defaultValue={customerid}
                    />
                  }
                  fullWidth
                >
                  <MenuItem value="show_all_customers">
                    {translate("jobs_context_all_customers")}
                  </MenuItem>
                  <Divider />
                  {customers
                    ? customers.data.map((customer, index) => {
                        return (
                          <MenuItem key={index} value={customer.id}>
                            {customer.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </Select>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </FormControl>
          <FormControl className={classes.textField} margin="normal">
            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                <Typography className={classes.heading}>
                  {translate("jobs_context_filter_job_sync_panel")}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.synced}
                        onChange={this.handleSyncChange("synced")}
                        value="synced"
                      />
                    }
                    label={translate("jobs_context_filter_job_synced")}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.notsynced}
                        onChange={this.handleSyncChange("notsynced")}
                        value="notsynced"
                      />
                    }
                    label={translate("jobs_context_filter_job_not_synced")}
                  />
                </FormGroup>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </FormControl>

          <FormControl className={classes.textField} margin="normal">
            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                <Typography className={classes.heading}>
                  {translate("jobs_context_filter_device_type_panel")}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <FormGroup>
                  {displayDeviceTypes
                    ? displayDeviceTypes
                        .filter(device => device.id !== "1_g")
                        .map((deviceType, index) => {
                          return (
                            <FormControlLabel
                              key={deviceType.id}
                              control={
                                <Checkbox
                                  checked={
                                    !!this.state[deviceType.id]
                                  }
                                  onChange={this.handleDeviceTypeChange(
                                    deviceType.id
                                  )}
                                  value={deviceType.id}
                                />
                              }
                              label={translate(deviceType.id)}
                            />
                          );
                        })
                    : null}
                </FormGroup>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </FormControl>
          {/* <FormControl className={classes.formControl}> */}
          {/* <TextField
            id="created_date"
            label={translate('jobs_context_filter_created_at_panel')}
            type="date"
            className={classes.textField}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={this.handleDate()}
            value={date}
            fullWidth
          /> */}
          <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
            <div className="picker">
              <DatePicker
                value={selectedDate}
                onChange={this.handleDateChange}
                disableFuture={true}
                clearable
                format="DD/MM/YYYY"
                keyboard
              />
            </div>
          </MuiPickersUtilsProvider>
          {/* </FormControl> */}
        </form>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { filter, syncChange } = nextProps;
    const { date } = this.state;
    if (filter) {
      if (syncChange) {
        (filter.synced = false), (filter.notsynced = false);
      }
      this.setState({
        ...filter
      });
    }
  }
}

export default withStyles(styles)(Context);
